var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGitbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000022523180236086361840000005299639162107031476_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.2 23.5",
    style: {
      enableBackground: "new 0 0 24.2 23.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29891",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_29890",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31018",
    className: "st0",
    d: "M10.9,17.3c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7 C10.3,17.6,10.6,17.3,10.9,17.3C10.9,17.3,10.9,17.3,10.9,17.3 M21.4,13.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 s0.7,0.3,0.7,0.7C22.1,12.8,21.8,13.1,21.4,13.1 M21.4,10.4c-1.1,0-2.1,0.9-2.1,2.1c0,0.2,0,0.4,0.1,0.6l-6.8,3.6 c-0.4-0.6-1-0.9-1.7-0.9c-0.8,0-1.5,0.4-1.9,1.1l-6.1-3.2c-0.6-0.4-1.1-1.4-1.1-2.4c0-0.5,0.2-0.9,0.5-1c0.2-0.1,0.4-0.1,0.6,0 l0,0c1.6,0.9,7,3.6,7.2,3.7c0.4,0.1,0.5,0.2,1.1-0.1l11-5.7c0.2-0.1,0.4-0.2,0.4-0.5c0-0.3-0.3-0.5-0.3-0.5 c-0.6-0.3-1.6-0.7-2.5-1.2c-2-0.9-4.3-2-5.3-2.5c-0.9-0.5-1.6-0.1-1.7,0l-0.2,0.1C8.1,6.1,2.1,9.1,1.7,9.3c-0.6,0.4-1,1.1-1,2 c-0.1,1.5,0.7,3,1.7,3.5l6.5,3.4c0.1,1,1,1.8,2,1.8c1.1,0,2-0.9,2.1-2l7.1-3.9c0.9,0.7,2.2,0.5,2.9-0.4s0.5-2.2-0.4-2.9 C22.3,10.5,21.9,10.4,21.4,10.4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGitbook);
export default __webpack_public_path__ + "static/media/icon-gitbook.3afe8c341a8fbc0abf71f2ec5d4269ce.svg";
export { ForwardRef as ReactComponent };